// src/app/interceptors/error/error.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError }         from 'rxjs/operators';

import { UserService }        from 'src/app/services/user/user.service';
import { ToastrService }      from 'ngx-toastr';
import { Router }             from '@angular/router';
import { AppConstants }       from 'src/app/constants/app-constants';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    private _toastrService: ToastrService,
    private _router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        // If on login screen, don't handle errors
        if (this._router.url.includes(AppConstants.MENU_LOGIN)) return throwError(() => res);

        switch (res.status) {
          case 400: // On 400, only show select errors
            const errorMessage = res.error?.message || '';
            if (!errorMessage || errorMessage === "") break;

            if (errorMessage.toLowerCase().includes('concurrent sessions not allowed')) {
              this._toastrService.error('Concurrent sessions are not allowed. Please refresh the page and login again.');
            }
            break;

          case 401: // On unauthorized, redirect to login if authenticated
            if (this._authService.authenticated) {
              this._authService.logout();
              this._router.navigate([AppConstants.MENU_LOGIN]);
            }
            break;

          case 0: // On empty status, backend is offline
            console.error('[ERR]: backend is offline');
            this._toastrService.error('Server is offline');
            break;

          case 403: // On forbidden, check if user is deactivated
            if (res.error && res.error.message && res.error.message.includes('deactivated')) {
              this._toastrService.error('Your account has been deactivated. Please contact support.');
              this._authService.logout();
              this._router.navigate([AppConstants.MENU_LOGIN]);
            } else {
              // Otherwise, generic permission denied message
              this._toastrService.error('You do not have permission to perform this action.');
            }
            break;

          case 500: // Internal server error, display generic error
            console.error('[ERR]: internal server error', res.error);
            break;

          default: // Otherwise, return nice error message if available
            console.error('[ERR]: error in http response', res.error);
            break;
        }

        return throwError(() => res);
      })
    );
  }
}
